import { render, staticRenderFns } from "./resourcesUpload.vue?vue&type=template&id=aad74f54&scoped=true&"
import script from "./resourcesUpload.vue?vue&type=script&lang=js&"
export * from "./resourcesUpload.vue?vue&type=script&lang=js&"
import style0 from "./resourcesUpload.vue?vue&type=style&index=0&id=aad74f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad74f54",
  null
  
)

export default component.exports